import React from 'react';

interface ChipProps {
    label: string;
    onDelete: () => void;
}

const Chip: React.FC<ChipProps> = ({ label, onDelete }) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#e0e0e0',
            borderRadius: '16px',
            padding: '2px 10px',
            margin: '2px',
            fontSize: '14px',
            color: '#333',
            border: '1px solid #ccc'
        }}>
            <span>{label}</span>
            <button
                type="button"
                onClick={onDelete}
                style={{
                    background: 'none',
                    border: 'none',
                    marginLeft: '5px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    lineHeight: '1',
                    padding: '0',
                    color: '#666'
                }}
            >
                &times;
            </button>
        </div>
    );
};

export default Chip;
